export default __webpack_public_path__ + "static/media/app_store_es.bc588dbd.svg";